<template>
  <panel 
    title="Clients">

      <div 
        v-if="activate && tempClients && tempClients.length > 0">
        <v-layout 
          column
          wrap>
          <v-flex 
            xs12>
            <v-card
              flat>
              <div 
                v-if="groupId">
                <v-flex 
                  offset-md5
                  offset-lg6
                  >
                  <v-btn
                    :color="strongColor"
                    mb-4
                    dark
                    large
                    @click="insertIntoGroup"
                    >Add Client(s) To Group</v-btn>
                </v-flex>
              </div>
              <v-list  
              >
                <v-list-tile 
                  v-for="client in tempClients" 
                  :key="client.id">
                  <v-list-tile-action>
                    <p-check
                      v-model="checkedClients"
                      :name="client.name"
                      :value="{name: client.name, id: client.id}"
                      checked="false"
                    />
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title 
                      v-text="callFixName(client.name)"/>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
      <!--<div v-else-if="tempClients === null">No matching results</div> -->
      <div v-else-if="tempClients && tempClients.length === 0">No matching results</div>
      <div
			v-else>
     	<v-progress-circular
				indeterminate
				color="primary"
				/> 
			</div>
  </panel>
</template>

<script>
import ClientsGroupService from "@/services/ClientsGroupService"
import ClientsService from "@/services/ClientsService"
import { fixName, STRONG_COLOR } from "@/components/globals/consts"
import EventBus from "@/main"
import {mapState} from 'vuex'
import _ from 'lodash'

export default {
  props: {
    groupId: {
      type: Number,
      required: false
    } //,
  },
  data() {
    return {
      tempClients: null,
      checkedClients: [],
      strongColor: STRONG_COLOR,
      clientsNotInArray: [],
      activate: false,
      search: null,
      fields: [
        { key: "attr", label: "Basic Desire", class: "text-left" },
        {
          key: "value",
          label: "Score",
          class: "text-right"
        }
      ] // client IDs
    };
  },
  	computed: {
		...mapState([
			'isUserLoggedIn',
			'user',
      'currentGroupClients',
      'renderClientList',
      'route'
		])
  },
    watch: {
    '$route': 'loadClients'
  },

  async mounted() {
    this.tempClients = null  
    
    await EventBus.$on("changeGroupClients", async (val) => {
      if (val === 1) {
        await this.loadClients() 
        await this.reloadSearch()
     }
    })

    await EventBus.$on("searchGroupClients", async (clientsArray, search) => {
      this.tempClients = null
      this.search = search

      if (clientsArray === undefined || (clientsArray && clientsArray.length === 0)) {
        this.tempClients = new Array()
      }
      else {
        try {
          this.activate = true
          this.tempClients = null
          this.clientsNotInArray = [];
          if (clientsArray !== undefined && clientsArray !== null) {
            for (let existingClient in clientsArray) {
              let found = this.currentGroupClients.find(
                client => client.id === clientsArray[existingClient].id
              );
              if (!found) {
                await this.clientsNotInArray.push(clientsArray[existingClient]);
              }
            }
            if (this.clientsNotInArray && this.clientsNotInArray.length > 0) {
              this.tempClients = await this.clientsNotInArray.sort(this.orderByName);
            } else {
              this.tempClients = new Array()
            }
          }          
        } catch (e) {
          //console.log(e);
        }
      }
    })
  },
  methods: {
    callFixName(name) {
      return fixName(name);
    },
    orderByName(a, b) {
      if (a && b && a.name && b.name && a.name.toUpperCase() && b.name.toUpperCase()) {
        if (a.name.toUpperCase() > b.name.toUpperCase()) {
          return 1;
        } else if (a.name.toUpperCase() < b.name.toUpperCase()) {
          return -1;
        }
        return 0;
      }
    },
    async insertIntoGroup() {   
      try {
        if (this.groupId) {
          for (let client of this.checkedClients) {
            let clientsGroup = {};
            if (client && client.id && this.groupId) {
              clientsGroup.clientId = client.id;
              clientsGroup.groupId = Number(this.groupId);
              let z = await ClientsGroupService.post(clientsGroup)
              this.tempClients = await this.arrayRemove(this.tempClients,client.id)
            }
          }

          this.checkedClients = [];
          this.checkedClientsToRemove = [];
          console.log('insert into group')
          await this.loadClients()

          this.$router.push({
            name: 'group-edit-clients',
            params: {
                groupId: this.groupId
              }
          })        
        }
      } catch (err) {
       // console.log(err);
      }
    },

    async loadClients () {
			try {
				this.clientsGroup = (await ClientsGroupService.show(this.groupId)).data
        console.log()
        let tempClientArr = []
				
				for (let client of this.clientsGroup) {			
					let x = {}
					x.name = client.Client.name
					x.id = client.Client.id
					x.clientsGroupId = client.id
					x.scores = (await ClientsService.show(x.id)).data
          tempClientArr.push(x)
        }
        let newTempClients = tempClientArr.slice()
        newTempClients = newTempClients.sort(this.orderByName)
        await this.$store.dispatch('setCurrentGroupClients', newTempClients)

			} catch (e) {
				console.log(`error in ${e}`)
			}
    },
    async reloadSearch() {
      
      let clientsArray = (await ClientsService.index(this.search)).data
      //console.log(clientsArray)
      this.tempClients = null
      if (clientsArray === undefined || (clientsArray && clientsArray.length === 0)) {
        this.tempClients = new Array()
      }
      else {
        try {
          this.activate = true
          this.tempClients = null
          this.clientsNotInArray = [];
          if (clientsArray !== undefined && clientsArray !== null) {
            for (let existingClient in clientsArray) {
              let found = this.currentGroupClients.find(
                client => client.id === clientsArray[existingClient].id
              );
              if (!found) {
                this.clientsNotInArray.push(clientsArray[existingClient]);
              }
            }
            if (this.clientsNotInArray && this.clientsNotInArray.length > 0) {
              this.tempClients = await this.clientsNotInArray.sort(this.orderByName);
            } else {
              this.tempClients = new Array()
            }
          }          
        } catch (e) {
          console.log(e);
        }
      }
    },
      arrayRemove(arr, value) {
      return arr.filter(function(element) {
        //console.log(element)
        return element.id != value;
      })
    }




  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/EditClientsInGroup/EditClientsGroupPanel.vue